<template>
  <div class="news-search">
    <app-header></app-header>
    <main>
      <b-tabs
          class="tabs-materialize tabs-news"
          fill>
        <b-tab class="tab-news-location" title="จังหวัด" active>
          <news-location></news-location>
          <app-footer></app-footer>
        </b-tab>
        <b-tab class="tab-news-category" title="ประเภทข่าว">
          <news-category></news-category>
          <app-footer></app-footer>
        </b-tab>
        <b-tab class="tab-news-organization" title="องค์กร">
          <news-organization></news-organization>
        </b-tab>
      </b-tabs>
    </main>
  </div>
</template>

<script>
  import AppHeader from '../components/Header.component'
  import AppFooter from '../components/Footer.component'
  import NewsLocation from '../components/NewsLocation.component'
  import NewsCategory from '../components/NewsCategory.component'
  import NewsOrganization from '../components/NewsOrganization.component'

  export default {
    name: 'news',
    components: {
      AppHeader,
      AppFooter,
      NewsLocation,
      NewsCategory,
      NewsOrganization
    }
  }
</script>

<style lang="scss" scoped>
  @import "../styles/styles";

  main {
    margin-top: $header-height;
  }
</style>



// WEBPACK FOOTER //
// src/pages/NewsSearch.page.vue